import { component as defineComponent } from 'flightjs';
import withHistory from 'app/mixins/with-history';
import URI from 'urijs';

var EntryPane = function() {
    this.attributes({
        designPaneEndPoint: null,
    });

    this.after('initialize', function() {
        this.initializeHistory();

        this.on('uiDesignsRefreshRequested', this.reloadEntries);
        this.on('uiHistoryPopped', this.loadEntriesOnPopState);
        this.on('uiEntryPaneCriteriaChanged', this.loadEntriesAndRecordHistory);

        this.lastLoadedEntriesURL = this.getAjaxEndPointUrl(window.location.href);

        window.addEventListener('ddoDidClose', this.reloadEntries.bind(this));
    });

    this.getAjaxEndPointUrl = function(url) {
        var uri;

        if (this.attr.designPaneEndPoint) {
            uri = new URI(url);
            uri.path(this.attr.designPaneEndPoint);
            return uri.toString();
        }

        return null;
    };

    this.loadEntries = function(endPointUrl, scrollAfterLoaded) {
        var jqXhr;

        if (!endPointUrl) {
            return null;
        }

        this.trigger('dataEntryPaneLoading');

        jqXhr = $.ajax({
            url: endPointUrl,
            dataType: 'html',
        });

        jqXhr.done(
            function(html) {
                this.trigger('dataEntryPaneContentReceived', { html: html });
                this.lastLoadedEntriesURL = endPointUrl;
            }.bind(this)
        );

        jqXhr.always(
            function(res, textStatus, errorThrown) {
                this.trigger('dataEntryPaneLoadingFinished', { noscroll: !scrollAfterLoaded });
            }.bind(this)
        );

        return jqXhr;
    };

    this.loadEntriesAndRecordHistory = function(e, data) {
        var loadEntriesURL = this.getAjaxEndPointUrl(data.url);
        var jqXhr = this.loadEntries(loadEntriesURL, !data.noscroll);

        if (jqXhr) {
            jqXhr.done(
                function() {
                    this.pushHistory(data.url);
                }.bind(this)
            );
        }
    };

    this.reloadEntries = function() {
        this.loadEntries(this.lastLoadedEntriesURL, false);
    };

    this.loadEntriesOnPopState = function() {
        var loadEntriesURL = this.getAjaxEndPointUrl(window.location.href);
        var uri = new URI(loadEntriesURL);
        var lastUri = this.lastLoadedEntriesURL ? new URI(this.lastLoadedEntriesURL) : null;

        if (!lastUri || lastUri.query() !== uri.query()) {
            this.loadEntries(loadEntriesURL, false);
        }
    };
};

export default defineComponent(EntryPane, withHistory);



// WEBPACK FOOTER //
// ./src/web/js/contest/data/entry-pane.js